import { RESET_API_SOURCE_FORM } from '../actionTypes';
import { actions } from '../reducer';

export default () => actions[RESET_API_SOURCE_FORM]();
